export default __webpack_public_path__ + "static/media/bell.c2ec0a9c.svg";